import React from 'react';

import { IWidgetCell } from '../../../../../types/IWidgetCell';

import './chartCashflowCell.scss';

const GridCell: React.FC<IWidgetCell> = ({ dataItem, node, chartClick, measure, field }) => {
    return (
        <td>
            {field && (
                <div className='cashflow-cell' onClick={(e) => chartClick(e, dataItem, node, measure, field)}>
                    {dataItem[field]}
                </div>
            )}
        </td>
    );
};

export default GridCell;